import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import db from './db'
import Buefy from 'buefy'
import '@/assets/scss/main.scss'
import Notifications from '@/plugins/notifications'
import VueCookieConsent from '@/plugins/vue-cookie-consent'
import filters from '@/plugins/filters'
import directives from "@/plugins/directives"
import VueScreen from 'vue-screen'
import VueYoutube from 'vue-youtube'
import VueSocialSharing from 'vue-social-sharing'
import pageTitleMixin from './mixins/pageTitleMixin'
import firebase from 'firebase/app'
import 'firebase/messaging'
import handleErrors from '@/mixins/handleErrors'
import authMixin from '@/mixins/auth'
import Vue2TouchEvents from 'vue2-touch-events'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueGtm from '@gtm-support/vue2-gtm'
import './lib/fontAwesome'

//service worker config
import './registerServiceWorker'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MESASUREMENT_ID
}
firebase.initializeApp(firebaseConfig)

//global mixins
Vue.mixin(handleErrors)
Vue.mixin(authMixin)

//touch events
Vue.use(Vue2TouchEvents)

//vue app config
Vue.config.productionTip = false
Vue.config.devtools = process.env.VUE_APP_ENV === 'dev'
Vue.config.debug = process.env.VUE_APP_ENV === 'dev'
Vue.config.silent = process.env.VUE_APP_ENV === 'prod'
Vue.use(filters)
Vue.use(directives)
Vue.use(api, {baseApi: process.env.VUE_APP_BASE_API})
Vue.use(db)
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});
Vue.use(Notifications, Buefy)
Vue.use(VueCookieConsent)
Vue.use(VueYoutube)
Vue.use(VueSocialSharing);
Vue.use(VueScreen, 'bulma')
Vue.use(VueTelInput)

//Mixins
Vue.mixin(pageTitleMixin)

if (process.env.VUE_APP_GTM_ID !== '') {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  })
}

store.dispatch("initSession").then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}).catch((e) => {
  console.error(e)
})


